export const auctionTags = ['auction_addSheet'] as const;
